import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './bodor-tube-cutting/HeroSection';
import { IntroSection } from './bodor-tube-cutting/IntroSection';
import { KSeriesSection } from './bodor-tube-cutting/KSeriesSection';
import { MSeriesSection } from './bodor-tube-cutting/MSeriesSection';
import { TSeriesSection } from './bodor-tube-cutting/TSeriesSection';
import { TASeriesSection } from './bodor-tube-cutting/TASeriesSection';
import { CTSeriesSection } from './bodor-tube-cutting/CTSeriesSection';
export function BodorTubeCuttingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1059">
      <SeoBar data-id="element-1060" />
      <Header data-id="element-1061" />
      <main className="flex-grow" data-id="element-1062">
        <div className="w-full bg-white pb-20" data-id="element-1063">
          <HeroSection data-id="element-1064" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1065">
            <IntroSection data-id="element-1066" />
            <div className="space-y-20" data-id="element-1067">
              <KSeriesSection data-id="element-1068" />
              <MSeriesSection data-id="element-1069" />
              <TSeriesSection data-id="element-1070" />
              <TASeriesSection data-id="element-1071" />
              <CTSeriesSection data-id="element-1072" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1073" />
    </div>;
}